export default "__VITE_ASSET__99f621b8__"